import React from 'react';

export interface KpiCardProps {
  label: string;
  value: string | number;
  variation?: { value: number; positive?: boolean };
  loading?: boolean;
}

const KpiCard: React.FC<KpiCardProps> = ({ label, value, variation, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm">
        <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse mb-3" />
        <div className="h-8 bg-gray-200 rounded w-3/4 animate-pulse" />
      </div>
    );
  }

  const isPositive = variation?.positive ?? (variation ? variation.value >= 0 : false);
  const arrow = isPositive ? '↑' : '↓';
  const variationClass = isPositive ? 'text-green-600' : 'text-red-600';

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm">
      <div className="text-sm text-gray-500 font-medium">{label}</div>
      <div className="mt-1 flex items-baseline gap-2">
        <div className="text-2xl font-semibold text-gray-900">{value}</div>
        {variation && (
          <div className={`text-sm font-medium ${variationClass}`}>
            {arrow} {Math.abs(variation.value)}%
          </div>
        )}
      </div>
    </div>
  );
};

export default KpiCard;
